import { useState } from "react";
import Courses from "./courses";
import Interview from "./interview";
import Experience from "./experience";

export default function Details(props) {
  const [activeTab, setActiveTab] = useState(3);

  return (
    <div className="bg-white rounded-3xl">
      <div className="flex  md:justify-content md:space-x-20 pt-2 px-8 lg:text-3xl transition-all duration-500 ease-out">
        <button
          onClick={() => setActiveTab(3)}
          className={`transition-all duration-100 ease-in border-b-2 w-24 lg:h-24 lg:w-36 ${
            activeTab === 3
              ? "border-primary text-black font-medium text-md md:text-lg"
              : "border-transparent text-gray-400 text-sm md:text-md"
          }`}
        >
          Interviews
        </button>
        <button
          onClick={() => setActiveTab(2)}
          className={`transition-all duration-100 ease-in border-b-2 w-24 lg:h-24 lg:w-36  ${
            activeTab === 2
              ? "border-primary text-black font-medium text-md md:text-lg"
              : "border-transparent text-gray-400 text-sm md:text-md"
          }`}
        >
          Courses
        </button>
        <button
          onClick={() => setActiveTab(1)}
          className={`transition-all duration-100 ease-in border-b-2 h-16 w-24 md:w-48 lg:h-24 lg:w-36 ${
            activeTab === 1
              ? "border-primary text-black font-medium text-md md:text-lg"
              : "border-transparent text-gray-400 text-sm md:text-md"
          }`}
          
        >
        <span className="hidden md:inline">Previous</span> Experiences
          
        </button>
      </div>
      {activeTab === 1 && <Experience exp={props.experience} />}
      {activeTab === 2 && <Courses course={props.course}/>}
      {activeTab === 3 && <Interview interview={props.interview} data={props.data}></Interview>}
    </div>
  );
}
